import * as React from 'react';
import {LegacyModal} from '@flexe/ui-components';

interface Props {
  showModal: boolean;
  toggleModal: () => void;
  onConfirmLpnDropoff: () => void;
}

export const ConfirmInboundArrivalModal: React.FC<Props> = (props) => {
  return (
    <LegacyModal
      id="complete_modal"
      show={props.showModal}
      size="small"
      title="Confirm Arrival"
      toggleModal={props.toggleModal}
      footer={
        <div>
          <a data-testid="cancel-inbound-arrival-btn" className="btn" onClick={props.toggleModal}>
            Cancel
          </a>
          <a
            data-testid="confirm-inbound-arrival-btn"
            className="btn cta btn-modal-complete"
            onClick={props.onConfirmLpnDropoff}
          >
            Confirm
          </a>
        </div>
      }
    >
      <p data-testid="inbound-arrival-confirmation-modal">
        This inbound is scheduled to arrive in the future.
        <br />
        Are you sure you want to confirm this inbound early?
      </p>
    </LegacyModal>
  );
};

export default ConfirmInboundArrivalModal;
